module.exports = __webpack_public_path__ + "img/divine.91c45dc9.jpeg";